import { Component, OnInit , Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd} from '@angular/router';
import { ConfigService } from './Core/Abstract/config.service';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  
  constructor(private translateService: TranslateService,private router: Router,protected configService: ConfigService,protected titleService: Title,@Inject(DOCUMENT) private _document: HTMLDocument) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
         if(!event.url.includes('welcomeScreen')){
          document.querySelector("body").style.background = "none";
         }
      }
  });
  }
 
  ngOnInit(): void {
    this.translateService.setDefaultLang(this.configService.getCurrentLocaleStr());
    this.titleService.setTitle(this.configService.getCustomPageTitle());
    this._document.getElementById('appFavicon').setAttribute('href', '/assets/images/logo/'+this.configService.getClient()+'/favicon.png');
  }
}